import { UPDATE_PRODUCER } from "./Constants"

export const updateProducer = ( dispatch, params ) => {
  dispatch({ type: UPDATE_PRODUCER, payload: params })
}